import React, {useEffect, useRef, useState} from "react";

// Cancel for a file input's upload, at whatever point it has reached: the checks on the file,
// waiting in line, "Checking your video…", or the transfer itself. A contributor who picked the
// wrong file of 70 otherwise had to wait for gigabytes to go up, or reload and lose every upload
// on the page.
//
// begin() is called when a file is picked and gives the signal to hand to uploadFile; end() when
// that pick is over, however it ended. `active` is true in between, which is when the button shows:
// an input's own `loading` also covers fetching the preview of a file already saved, where there
// is nothing to cancel. Leaving the page cancels too, so nothing keeps uploading for an input that
// no longer exists.
export function useUploadCancel() {
    const controllerRef = useRef(null);
    const [active, setActive] = useState(false);

    useEffect(() => () => controllerRef.current && controllerRef.current.abort(), []);

    return {
        active,
        begin() {
            controllerRef.current = new AbortController();
            setActive(true);
            return controllerRef.current.signal;
        },
        end() {
            setActive(false);
        },
        cancel() {
            controllerRef.current && controllerRef.current.abort();
        },
    };
}

export default function CancelUpload({onCancel}) {
    return (
        <button type="button" className="btn btn-sm btn-outline-danger mt-2" onClick={onCancel}>Cancel</button>
    );
}
